export default "__VITE_ASSET__aa909cbf__"